import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, DestroyRef, inject, OnDestroy, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Observable, take } from 'rxjs';

import { CookieConsent, CookieConsentService } from './cookie-consent.service';

import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';
import { ButtonModule } from 'primeng/button';
import { TabsModule } from 'primeng/tabs';
import { ToggleSwitchModule } from 'primeng/toggleswitch';
import { ContactsInfo } from '../common';

@Component({ 
  selector: 'vsf-cookie-banner',
  templateUrl: './cookie-banner.component.html',
  standalone: true,
  imports: [
    AsyncPipe, 
    ButtonModule, 
    TranslocoModule,   
    TabsModule, 
    ToggleSwitchModule,
    FormsModule,
    RouterModule
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CookieBannerComponent implements OnInit, OnDestroy {

  private cookieService = inject(CookieConsentService);
  private destroyRef = inject(DestroyRef);
  
  consent$: Observable<CookieConsent | null> = this.cookieService.consent$;
  private timeoutId: any;
  hydrated$ = this.cookieService.hydrated$;

  settingsOpen = false;
  functionalTemp = true;
  activeCookieTab = 'essential';

  ContactsInfo = ContactsInfo;

  ngOnInit() {
    this.cookieService.openSettings$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        this.openSettings();
      });
  }

  openSettings() {
    this.cookieService.consent$
      .pipe(take(1))
      .subscribe(consent => {
        this.functionalTemp = consent?.functional ?? true;
        this.settingsOpen = true;
      });

  }

  closeSettings() {
    this.settingsOpen = false;
  }

  saveSettings() {
    if (this.functionalTemp) {
      this.cookieService.acceptAll();
    } else {
      this.cookieService.rejectFunctional();
    }
    this.settingsOpen = false;

  }

  accept(): void {
    this.cookieService.acceptAll();
  }

  reject(): void {
    this.cookieService.rejectFunctional();
  }

  ngOnDestroy() {
    clearTimeout(this.timeoutId);
  }

}
